module.exports = __webpack_public_path__ + "img/img_050@2x.fe496af6.png";